import React, {useEffect, useRef, useState} from "react";
import "./style.scss";
import {Image} from "../Image";
import {NAV, NavigationEnum, PRIVACY_POLICY} from "../../enum/NavigationEnum";
import {Support} from "./Support";
import {Privacy} from "./Privacy";
export const Navigation = ({data, curIndex, back, status, isMobile, displayNav = false, setDisplayNav = () => {}}) => {
    const [curStatus, setCurStatus] = useState(null);
    const [curDisplayNav, setCurDisplayNav] = useState(displayNav);

    useEffect(() => {
        setCurDisplayNav(displayNav);
    }, [displayNav]);

    const ref = useRef(null);
    const iconRef = useRef(null);

    const updateDisplayNav = (nav) => {
        setCurDisplayNav(nav);
        setDisplayNav(nav);
    };

    const leftSlideIn = (dom) => {
        dom.current.style.transition = "none";
        dom.current.style.left = "100%";
        setTimeout(() => {
            dom.current.style.transition = "left 0.3s ease";
            dom.current.style.left = "0";
        }, 10);


    }
    const rightSlideIn = (dom) => {
        dom.current.style.transition = "none";
        dom.current.style.left = "-100%";
        setTimeout(() => {
            dom.current.style.transition = "left 0.3s ease";
            dom.current.style.left = "0";
        }, 10);

    }

    const leftSlideOut = (dom) => {
        dom.current.style.left = "-100%";
    }
    const rightSlideOut = (dom) => {
        dom.current.style.left = "100%";
    }

    const renderSupport = () => {
        if (curDisplayNav === NAV) {
            return <Support setDisplayNav={updateDisplayNav} />;
        } else if (curDisplayNav) {
            return <Privacy setDisplayNav={updateDisplayNav} displayNav={curDisplayNav} />;
        }
        return null;

    }


    useEffect(() => {
        if (isMobile) {
            if (status === NavigationEnum.SHOW_ICON || status === NavigationEnum.NORMAL) {
                if (curStatus === null) {
                    if (status === NavigationEnum.SHOW_ICON) {
                        iconRef.current.style.left = "0";
                        ref.current.style.left = "100%";
                    } else {
                        iconRef.current.style.left = "100%";
                        ref.current.style.left = "0";
                    }
                }
                setCurStatus(status);
                return;
            }

            if (curStatus === NavigationEnum.SHOW_ICON) {
                if (status === NavigationEnum.SLIDE_LEFT) {
                    leftSlideOut(iconRef);
                    leftSlideIn(ref);
                } else if (status === NavigationEnum.SLIDE_RIGHT) {
                    rightSlideOut(iconRef);
                    rightSlideIn(ref);
                }
            } else if (curStatus === NavigationEnum.NORMAL) {
                if (status === NavigationEnum.SLIDE_LEFT) {
                    leftSlideOut(ref);
                    leftSlideIn(iconRef);
                } else if (status === NavigationEnum.SLIDE_RIGHT) {
                    rightSlideOut(ref);
                    rightSlideIn(iconRef);
                }
            }
        }
        setCurStatus(status);

    }, [status]);


    if (isMobile) {
        return (
            <>
                {status !== NavigationEnum.NONE && <div className={'navigation'} ref={ref}>
                    <div className={'navigation-wrap'}>
                        <Image className={'back-icon'} src={"/static/image/icon/back.png"} width={44} height={44} onClick={back} style={{opacity: curIndex === 0 ? 0: 100}} />
                        <div className={'progress-bar'}>
                            <div className={'progress-bar-content'} style={{width: `${curIndex * 100 / data.length}%`}} />
                        </div>
                        <Image className={'back-icon'} src={"/static/image/icon/menu.png"} width={44} height={44}  onClick={() => {updateDisplayNav(NAV)}} />
                    </div>
                </div>}
                {status !== NavigationEnum.NONE && <div className={'navigation'} ref={iconRef}>
                    <div className={'navigation-wrap'}>
                        <Image className={'back-icon'} src={"/static/image/icon/back.png"} width={44} height={44} onClick={back} style={{opacity: curIndex === 0 ? 0: 100}} />
                        <Image className={'title-icon'} src={"/static/image/icon/calo.png"} width={60} height={20} />
                        <Image className={'back-icon'} src={"/static/image/icon/menu.png"} width={44} height={44} onClick={() => {updateDisplayNav(NAV)}} />
                    </div>
                </div>}
                {renderSupport()}
            </>
        );
    }


    return (
        <>

            <div className={'navigation'} ref={ref}>
                <div className={'navigation-container'}>

                    <div className={'navigation-wrap'}>
                        <Image className={'title-icon'} src={"/static/image/icon/calo.png"} width={72} height={24} />
                        <Image className={'menu-icon'} src={"/static/image/icon/menu.png"} width={48} height={48} onClick={() => {updateDisplayNav(NAV)}} />
                    </div>
                    {status !== NavigationEnum.NONE && <div className={'progress-bar'}>
                        <div className={'progress-bar-content'} style={{width: `${curIndex * 100 / data.length}%`}} />
                    </div>}
                    {status !== NavigationEnum.NONE && <Image className={'back-icon'} src={"/static/image/icon/back.png"} width={48} height={48} onClick={back} style={{opacity: curIndex === 0 ? 0: 100}} />}
                </div>
            </div>
            {renderSupport()}

        </>
    );
};

Navigation.propTypes = {};
